//
import React from 'react';
//
import Button from 'antd/lib/button';
import notification from 'antd/lib/notification';
//
import DownloadPDFButton from 'components/common/DownloadPDFButton';
import { contractStatusesObject } from 'lib/constants/contractStatuses';
// APOLLO
import { graphql } from 'react-apollo';
import sendContractReminder from 'ApolloClient/Mutations/sendContractReminder';
import ErrorHelpers from '../../../../lib/helpers/ErrorHelpers/index';

const s = {
  bigButton: {
    alignSelf: 'center',
    display: 'block',
    minWidth: 225,
    height: 45,
    fontSize: 18,
    maxWidth: '100%',
  },
};

class SignedPDFButton extends React.PureComponent {
  state = {
    loading: false,
  };

  onSendContractReminder = async () => {
    this.setState({ loading: true });
    try {
      await this.props.sendContractReminder({
        variables: {
          _id: this.props.contractId,
        },
      });
    } catch (err) {
      this.setState({ loading: false });
      return ErrorHelpers.handleError(err);
    }
    this.setState({ loading: false });
    notification.success({ message: 'We sent a reminder email sent!' });
  };

  render() {
    const {
      contractStatus,
      toggleSendModal,
      contractId,
      clientSigned,
      contractorSigned,
      currentUserIsContractor,
    } = this.props;

    // if the contractor has signed, and the current view IS THE CONTRACTOR, then show this text
    if (clientSigned && contractorSigned) {
      return (
        <DownloadPDFButton
          record={{ _id: contractId }}
          size="large"
          downloadType="contract"
          buttonStyle={s.bigButton}
        />
      );
    }

    // if user is not signed in, then hide the button
    if (!currentUserIsContractor) {
      return null;
    }

    // if user is not signed in, then hide the button
    if (contractStatus === contractStatusesObject.sent) {
      return (
        <Button
          type="primary"
          size="large"
          loading={this.state.loading}
          disabled={this.state.loading}
          className="contract-flow-btn"
          onClick={this.onSendContractReminder}
        >
          RESEND EMAIL
        </Button>
      );
    }

    // if the contractor has signed, and the current view IS THE CONTRACTOR, then show this text
    if (!clientSigned && contractorSigned && currentUserIsContractor) {
      return (
        <Button type="primary" size="large" className="contract-flow-btn" onClick={() => toggleSendModal()}>
          SEND CONTRACT
        </Button>
      );
    }

    return null;
  }
}

export default graphql(sendContractReminder, { name: 'sendContractReminder' })(SignedPDFButton);



// WEBPACK FOOTER //
// ./src/routes/contract-view/SignedPDF/SignedPDFButton/index.js